<template>
  <div class="card">
    <slot></slot>
  </div>
</template>

<style lang="scss">
.card {
  //margin-top: var(--attendee-gap-md);
  padding: var(--attendee-gap-lg);
  box-shadow: var(--attendee-box-shadow);
  background-color: var(--attendee-card-color);
  border-radius: var(--attendee-card-border-radius);

  @media (max-width: 900px) {
    padding: var(--attendee-gap-md);
  }
}
</style>

<script>
export default {}
</script>